import { mapKeys, mapValues, camelCase } from 'lodash'

let env = process.env
env = mapKeys( env, ( value, key ) => camelCase( key.replace( /REACT_APP_/, '' ) ) )
env = mapValues( env, value => value === "false" ? false : ( value === "true" ? true : value ) )

export default { ...env }